import { EmpresaModais } from 'app/main/empresa/modal';
import empresaApi from 'app/services/api/empresaApi';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useCallback, useContext, useRef, useState } from 'react';
import { FaCut } from 'react-icons/fa';
import ReactCrop from 'react-image-crop';
import { CancelButton, SaveButton } from '../Buttons';
import { SimpleDialog, SimpleDialogContent } from '../Dialog';

const getExtension = (arquivo) => {
  const { name } = arquivo;
  const lastDot = name.lastIndexOf('.');
  const ext = name.substring(lastDot + 1).toLowerCase();
  return ext;
};

const getCroppedImg = async (imgRef, crop, onBlob = () => {}) => {
  if (!imgRef.current) {
    return;
  }
  const image = imgRef.current;
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = 400;
  canvas.height = 400;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, 400, 400);

  canvas.toBlob(
    (blob) => {
      onBlob(blob);
    },
    'image/jpeg',
    1
  );

  return canvas.toDataURL();
};

const UploadImageCrop = ({ modal, imgCrop, setUpImg, closeModal, imgOriginal }) => {
  const [crop, setCrop] = useState({ aspect: 1, height: 100, width: 100, unit: 'px', x: 0, y: 0 });
  const imgRef = useRef(null);
  const [, setCompletedCrop] = useState(null);
  const [empresa, setEmpresa] = useContext(GlobalContext).empresa;

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  return (
    <>
      <SimpleDialog open={modal === EmpresaModais.recortarLogo} onClose={null}>
        <SimpleDialogContent
          header={{
            title: 'Recortar Logomarca',
            icon: <FaCut />,
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={() => closeModal('')}>
                  Fechar
                </CancelButton>
                <SaveButton
                  color="buttonSave"
                  onClick={async () => {
                    const onBlob = async (blob) => {
                      const formData = new FormData();
                      formData.append('arquivo', blob, `${imgOriginal.name}.${getExtension(imgOriginal)}`);
                      formData.append('empresaId', empresa.id);

                      const resp = await empresaApi.uploadLogoMarca(formData);
                      empresa.logomarcaId = resp.data.id;
                      setEmpresa({ ...empresa });
                    };

                    const cropped = await getCroppedImg(imgRef, crop, onBlob);
                    setUpImg(cropped);
                    empresa.logomarca = cropped;
                    setEmpresa(empresa);

                    closeModal('');
                  }}
                >
                  Recortar
                </SaveButton>
              </>
            ),
          }}
          content={
            <>
              <div style={{ textAlign: 'center', marginTop: 10 }}>
                <ReactCrop
                  src={imgCrop}
                  onImageLoaded={onLoad}
                  crop={crop}
                  onChange={(c) => setCrop(c)}
                  onComplete={(c) => setCompletedCrop(c)}
                />
              </div>
            </>
          }
        />
      </SimpleDialog>
    </>
  );
};

export default UploadImageCrop;
